import { DataTableColumnDef } from "@/components/molecules";
import { BookingHistoryTableData } from "./types";

export const bookingHistoryColumns: DataTableColumnDef<BookingHistoryTableData>[] = [
  {
    accessorKey: "date",
    header: "Date",
    id: "date",
    cell: (props) => props.row.original.date,
    size: 140,
  },
  {
    accessorKey: "jobId",
    header: "Job ID",
    id: "job_id",
    cell: (props) => props.row.original.jobId,
    size: 110,
  },
  // Status sits beside Job ID, not out past Destination: it's the first thing anyone scans the list
  // for, and behind the addresses it was only reachable by scrolling the table right.
  {
    accessorKey: "status",
    header: "Status",
    id: "status",
    cell: (props) => props.row.original.status,
    size: 130,
    enableSorting: false,
  },
  {
    accessorKey: "passenger",
    header: "Passenger",
    id: "passenger",
    cell: (props) => props.row.original.passenger,
    size: 160,
  },
  // No fixed `size`: pickup/destination flex to fill the leftover width of the width:100% table
  // instead of leaving dead space beside a fixed cell. The address text fills the cell — see helpers.tsx.
  {
    accessorKey: "pickupLocation",
    header: "Pick-up Location",
    id: "pickup",
    cell: (props) => props.row.original.pickupLocation,
  },
  {
    accessorKey: "destination",
    header: "Destination",
    id: "destination",
    cell: (props) => props.row.original.destination,
  },
  {
    accessorKey: "cost",
    header: "Cost",
    id: "cost",
    cell: (props) => props.row.original.cost,
    size: 100,
  },
  // Pinned to the right edge: the row menu is the one cell that's needed on every row regardless of
  // how far the addresses push the table, and it was the other thing you had to scroll to reach.
  // The rows carry `[&_tbody]:bg-white` (see BookingHistoryTable), which is the opaque background a
  // pinned cell needs to paint over the ones scrolling beneath it.
  {
    accessorKey: "action",
    header: "Action",
    id: "action",
    cell: (props) => props.row.original.action,
    size: 75,
    enableSorting: false,
    sticky: "right",
  },
];

/**
 * Owning-client column for the EA managed (All Bookings) list. Inserted right after Passenger,
 * ONLY in managed mode — the self / operator lists never render it (their rows carry no `managedClient`).
 */
export const managedClientColumn: DataTableColumnDef<BookingHistoryTableData> = {
  accessorKey: "managedClient",
  header: "Client",
  id: "managed_client",
  cell: (props) => props.row.original.managedClient,
  size: 160,
  enableSorting: false,
};
